document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".footer__accordion-title");
  accordions.forEach((button) => {
    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", !expanded);
    });
  });
});
